import React, { Fragment, useRef, useState } from 'react';
import './HeaderContacts.scss';
import 'theme/vendor/slick.min.scss';
import { CustomLPSlider, PositionSlider } from '../Components/CustomLPSlider';
import { navCards } from './constants';

export const HeaderContacts = () => {
  const [current, setCurrent] = useState(0);
  const scrollRef = useRef();

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const children = Array.from(container.querySelectorAll('.custom-lp-slider'));
    const containerRect = container.getBoundingClientRect();
    let minDiff = Infinity;
    let activeIdx = 0;
    children.forEach((child, idx) => {
      const rect = child.getBoundingClientRect();
      const diff = Math.abs(rect.left - containerRect.left);
      if (diff < minDiff) {
        minDiff = diff;
        activeIdx = idx;
      }
    });
    setCurrent(activeIdx);
  };

  return (
    <Fragment>
      <div className="header-contacts__main">
        <div className="header-contacts__hero-section">
          <div className="header-contacts__hero-image">
            <div className="header-contacts__hero-text">
              <span className="header-contacts__hero-title">ELEVATE YOUR VISION</span>
              <p className="header-contacts__hero-description">
                More freedom with OWNDAYS contact lenses
              </p>
            </div>
            <button className="header-contacts__hero-button">EXPLORE PRODUCTS</button>
          </div>
        </div>
        <div className="header-contacts__carousel">
          <div className="header-contacts__carousel-desktop">
            {navCards.map((card, idx) => (
              <CustomLPSlider key={card.title} {...card} />
            ))}
          </div>
          <div ref={scrollRef} className="header-contacts__carousel-mobile" onScroll={handleScroll}>
            {navCards.map((card, idx) => (
              <CustomLPSlider key={card.title} {...card} />
            ))}
          </div>
          <PositionSlider current={current} />
        </div>
      </div>
    </Fragment>
  );
};
